import { useState, useEffect } from "react";
import axios from "axios";

/**
 * useIpAddress - React hook to get the client's IP address.
 * Simplified version that only uses ipify API.
 * 
 * Returns: [ip, loading, error]
 */
export default function useIpAddress() {
  const [ip, setIp] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    
    const fetchIp = async () => {
      try {
        // Simply get IP from ipify
        const response = await axios.get("https://api.ipify.org?format=json");
        
        if (isMounted) {
          setIp(response.data.ip);
          setLoading(false);
        }
      } catch (err) {
        console.error('Error fetching IP from ipify:', err);
        if (isMounted) {
          setError(`Could not determine IP address: ${err.message}`);
          setLoading(false);
        }
      }
    };
    
    fetchIp();
    
    return () => {
      isMounted = false;
    };
  }, []); // No dependencies needed anymore

  return [ip, loading, error];
}
